import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ResetPinDialogComponent} from './reset-pin-dialog.component';
import {ReactiveFormsModule} from '@angular/forms';
import {InputModule} from '../input/input.module';
import {ButtonModule} from '../button/button.module';
import {PinInputModule} from '../pin-input/pin-input.module';
import {DialogModule} from '../dialog/dialog.module';

@NgModule({
  declarations: [
    ResetPinDialogComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputModule,
    ButtonModule,
    PinInputModule,
    DialogModule,
  ],
  exports: [
    ResetPinDialogComponent,
  ],
})
export class ResetPinDialogModule {
}
